import React, { useEffect, useState } from "react";
import useAuth from "../../hooks/useAuth";
import useMatricula from "../../hooks/useMatricula";
import useProcesoMatricula from "../../hooks/useProcesoMatricula";
import { obtenerLabelEtiqueta } from "../../utils/idioma/LabelsIdioma";
import {
  resumenPagoEstudianteService,
  cuotasPagoService,
} from "../../services/Pagos";
import ModalExonerado from "./ModalExonerado";
import {
  listado_asignaturas_estudiante,
  listado_grupos_habilitados,
  update_paso,
} from "../../services/procesoMatricula/procesoMatricula";
const Pago = () => {
  let {
    setPasoProcesoM,
    resumenPagoEstudiante,
    setResumenPagoEstudiante,
    cuotasPagosEstudiante,
    setCuotasPagosEstudiante,
    stCuotaSelecionada,
    setCuotaSeleccionada,
    setLoading,
    setListadoAsignaturasEstudiante,
  } = useProcesoMatricula();

  const { listadoEtiquetas } = useAuth();
  const [etiquetas, setEtiquetas] = useState({});

  let {
    obtenerDatosEstudiante,
    setGruposHabilitados,
  } = useMatricula();


  useEffect(() => {
    if (dperiodo) {
      try {

        cuotasPagoService(
          obtenerDatosEstudiante,
          setCuotasPagosEstudiante,
          setLoading,
          2,
          dperiodo
        );
      } catch (error) {
      }
    }
  }, [obtenerDatosEstudiante]);

  useEffect(() => {
    let domSelect = document.querySelector("#seleccionDefault");

    if (domSelect) {
      domSelect.value = "";
    }

    let modalExonerad = document.querySelector("#modalEx");

    if (modalExonerad) {
      if (becado) {
        modalExonerad.click();
      }
    }
  }, [obtenerDatosEstudiante]);

  useEffect(() => {
    if (stCuotaSelecionada !== "") {

      try {
        resumenPagoEstudianteService(
          obtenerDatosEstudiante,
          stCuotaSelecionada,
          setResumenPagoEstudiante,
          setLoading
        );
      } catch (error) {
      } finally {
      }
    } else {
      setResumenPagoEstudiante({});
    }
  }, [stCuotaSelecionada]);

  const atrasBtnPago = async () => {
    try {
      setLoading(true);

      await listado_grupos_habilitados(
        obtenerDatosEstudiante,
        setGruposHabilitados
      );
      await listado_asignaturas_estudiante(
        obtenerDatosEstudiante,
        setListadoAsignaturasEstudiante
      );
      await update_paso(obtenerDatosEstudiante, 3, 1);
      setPasoProcesoM(3);
    } catch (error) {
    } finally {
      setLoading(false);
    }

  };

  function separator(numb) {
    var str = numb.toString().split(".");
    str[0] = str[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return str.join(".");
  }


  useEffect(() => {

    if (listadoEtiquetas.length > 0) {
      setEtiquetas({
        global_pago: obtenerLabelEtiqueta("lbl_global_pago", listadoEtiquetas),
        msj_seleccionar_modalidad: obtenerLabelEtiqueta(
          "lbl_pago_msj_seleccionar_modalidad",
          listadoEtiquetas
        ),
        pago_cuotas: obtenerLabelEtiqueta("lbl_pago_cuotas", listadoEtiquetas),
        pago_modalidad_pago: obtenerLabelEtiqueta(
          "lbl_pago_modalidad_pago",
          listadoEtiquetas
        ),
        pago_matricula: obtenerLabelEtiqueta(
          "lbl_pago_matricula",
          listadoEtiquetas
        ),
        pago_pension_semestral: obtenerLabelEtiqueta(
          "lbl_pago_pension_semestral",
          listadoEtiquetas
        ),
        pago_otros: obtenerLabelEtiqueta("lbl_pago_otros", listadoEtiquetas),
        pago_msj_total_neto: obtenerLabelEtiqueta(
          "lbl_pago_msj_total_neto",
          listadoEtiquetas
        ),
        pago_msj_primer: obtenerLabelEtiqueta(
          "lbl_pago_msj_primer",
          listadoEtiquetas
        ),
        pago_msj_restantes: obtenerLabelEtiqueta(
          "lbl_pago_msj_restantes",
          listadoEtiquetas
        ),
        pago_monto_cuota: obtenerLabelEtiqueta(
          "lbl_pago_monto_cuota",
          listadoEtiquetas
        ),
        reglamento_volver: obtenerLabelEtiqueta(
          "lbl_reglamento_volver",
          listadoEtiquetas
        ),
        datos_continuar: obtenerLabelEtiqueta(
          "lbl_update_datos_continuar",
          listadoEtiquetas
        ),
        lbl_pago_msj_seleccione_modalidad: obtenerLabelEtiqueta(
          "lbl_pago_msj_seleccione_modalidad",
          listadoEtiquetas
        ),
        lbl_pago_seleccionar_modalidad: obtenerLabelEtiqueta(
          "lbl_pago_seleccionar_modalidad",
          listadoEtiquetas
        ),
        lbl_pago_contado: obtenerLabelEtiqueta(
          "lbl_pago_contado",
          listadoEtiquetas
        ),
      });
    }
  }, [listadoEtiquetas]);
  const {
    global_pago,
    msj_seleccionar_modalidad,
    pago_cuotas,
    pago_modalidad_pago,
    pago_matricula,
    pago_pension_semestral,
    pago_otros,
    pago_msj_total_neto,
    pago_msj_primer,
    pago_msj_restantes,
    pago_monto_cuota,
    reglamento_volver,
    datos_continuar,
    lbl_pago_msj_seleccione_modalidad,
    lbl_pago_seleccionar_modalidad,
    lbl_pago_contado,
  } = etiquetas;

  const { primer_monto, cuotas_restante, valor_cuota } =
    resumenPagoEstudiante || "";

  let cuotasEnquePagara =
    cuotas_restante !== 0 ? cuotas_restante + 1 : cuotas_restante;

  const { becado, dperiodo } = obtenerDatosEstudiante;
  return (
    <div className="col-sm-12 col-md-12 col-lg-12 steps-container ">
      <button
        id="modalEx"
        style={{ display: "none" }}
        data-bs-toggle="modal"
        data-bs-target="#exonerado"
      >
        {" "}
        data
      </button>
      <div className="card shadow-sm">
        <div className="card-body">
          <fieldset>
            <div className="form-body pago">
              <div className="matricula-title">
                <h5 className="text-uppercase">{global_pago}</h5>
                <div className="separator"></div>
              </div>

              <div className="mb-3 modality-selector w-25">
                {becado == false &&
                  cuotasPagosEstudiante.length > 0 &&
                  cuotasPagosEstudiante[0].ccuota !== -1 && (
                    <>
                      <label className="control-label">
                        {msj_seleccionar_modalidad}:
                      </label>

                      <select
                        id="seleccionDefault"
                        className="form-control form-select-sm form-select"
                        defaultValue={""}
                        onChange={(e) => {
                          setCuotaSeleccionada(e.target.value);
                        }}
                      >
                        <option value={""}>
                          {lbl_pago_seleccionar_modalidad}
                        </option>
                        {cuotasPagosEstudiante.map((data, index) => {
                          return (
                            <option value={data.ccuota} key={index}>
                              {data.ncuota === 0
                                ? lbl_pago_contado
                                : data.ncuota + " " + pago_cuotas}{" "}
                            </option>
                          );
                        })}
                      </select>
                    </>
                  )}
              </div>

              {becado == false &&
                cuotasPagosEstudiante.length > 0 &&
                cuotasPagosEstudiante[0].ccuota == -1 && (
                  <div className="my-3">
                    <div className="mt-4">
                      <div className="alert alert-warning" role="alert">
                        <p className="mb-0" style={{ lineHeight: "1.2" }}>
                          <svg
                            style={{ width: 24, height: 24, marginRight: 5 }}
                            viewBox="0 0 24 24"
                          >
                            <path
                              fill="currentColor"
                              d="M13,13H11V7H13M13,17H11V15H13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z"
                            />
                          </svg>
                          La matrícula académica está en proceso, intente en
                          unos minutos y podrá seleccionar su modalidad de pago.
                        </p>
                      </div>
                    </div>
                  </div>
                )}
              {becado == false &&
                cuotasPagosEstudiante.length > 0 &&
                cuotasPagosEstudiante[0].ccuota != -1 && (
                  <p className="text-uppercase fw-bolder mt-4">
                    {stCuotaSelecionada === "" &&
                      lbl_pago_msj_seleccione_modalidad}
                    {stCuotaSelecionada !== "" &&
                      stCuotaSelecionada != 0 &&
                      pago_modalidad_pago +
                      " " +
                      cuotasEnquePagara +
                      " " +
                      pago_cuotas}

                    {stCuotaSelecionada == 0 &&
                      stCuotaSelecionada !== "" &&
                      "MODALIDAD DE PAGO AL CONTADO"}
                  </p>
                )}

              <div
                className="table-responsive table-schedule"
                id="no-more-tables"
              >
                {becado == false &&
                  cuotasPagosEstudiante.length > 0 &&
                  cuotasPagosEstudiante[0].ccuota != -1 && (
                    <table className="table table-striped">
                      <thead className="table-light">
                        <tr>


                          <th scope="col" style={{ textAlign: "center" }}>
                            {pago_msj_primer}
                          </th>

                          <th scope="col" style={{ textAlign: "center" }}>
                            {pago_msj_restantes}
                          </th>
                          <th scope="col" style={{ textAlign: "center" }}>
                            {pago_monto_cuota}
                          </th>
                        </tr>
                      </thead>

                      <tbody>
                        <tr>

                          <th style={{ textAlign: "center", fontWeight: 400 }}>
                            {primer_monto}
                          </th>
                          <td style={{ textAlign: "center" }}>
                            {cuotas_restante}
                          </td>
                          <td style={{ textAlign: "center" }}>{valor_cuota}</td>
                        </tr>
                      </tbody>
                    </table>
                  )}
              </div>
            </div>
            {becado == false &&
              cuotasPagosEstudiante.length > 0 &&
              cuotasPagosEstudiante[0].ccuota != -1 && (
                <>

                  <button
                    type="button"
                    className="btn waves-effect waves-light btn-primary siguiente"
                    data-bs-toggle="modal"
                    data-bs-target="#modalidad"
                  >
                    {datos_continuar}
                  </button>
                </>
              )}

            {becado == false &&
              cuotasPagosEstudiante.length > 0 &&
              cuotasPagosEstudiante[0].ccuota == -1 && (
                <>

                  <button
                    type="button"
                    className="btn waves-effect waves-light btn-secondary siguiente"
                    disabled
                  >
                    {datos_continuar}
                  </button>
                </>
              )}
          </fieldset>
        </div>
      </div>
      <ModalExonerado />
    </div>
  );
};

export default Pago;
